import _defineProperty from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import dayjs from 'dayjs';
export default {
  name: 'cms_work_order',
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '',
        queryFunName: 'workOrderQuery',
        activeWorkOrderFunName: 'workOrderRead',
        queryReplayFunName: 'workOrderReplayQuery',
        addReplayFunName: 'workOrderReplayAdd',
        addFunName: 'workOrderAdd'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        readState: null,
        replyState: null,
        sortField: 'create_time'
      },
      searchReplayForm: {
        page: 1,
        woId: null,
        limit: 10,
        searchKey: null
      },
      replayFormData: {
        id: null,
        woId: null,
        content: null
      },
      replayRules: {
        content: [{
          required: true,
          message: '回复内容不能为空',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      queryReplayLoading: true,
      tableData: [],
      replayTableData: [],
      totalCount: 0,
      replayTotalCount: 0,
      replayDialogShow: false,
      replayDialogTitle: '',
      replayFormLabelWidth: '80px',
      emptyReplayFormData: {},
      isMe: localStorage.getItem('userId'),
      workOrderDetail: {
        content: null,
        createUserNickname: null,
        userPhone: null
      },
      formLabelWidth: '100px',
      formData: {
        imgs: []
      },
      editDialogShow: false,
      editDialogTitle: '',
      emptyFormData: {},
      rules: {
        title: [{
          required: true,
          message: '标题不能为空',
          trigger: 'blur'
        }],
        content: [{
          required: true,
          message: '回复内容不能为空',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.emptyReplayFormData = JSON.parse(JSON.stringify(this.replayFormData));
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    var userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (userInfo.category == 'Business') {
      // 用户类别：业务用户
      this.searchForm.userId = userInfo.id;
    }
    this.query();
  },
  methods: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (!this.formData.imgs) {
        this.formData.imgs = [];
      }
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    submitFormData: function submitFormData() {
      var _this = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          _this.$api[_this.pageConfig.addFunName](_this.saveFormDataProcess(_objectSpread(_objectSpread({}, _this.formData), {}, {
            imgs: _this.formData.imgs ? JSON.stringify(_this.formData.imgs) : ''
          }))).then(function (res) {
            if (res.data) {
              _this.$message.success('新增成功');
              _this.initFormData(_this.emptyFormData);
              _this.editDialogShow = false;
              _this.query();
            } else {
              _this.$message.error('新增失败');
            }
          });
        }
      });
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    Upload: function Upload(_ref) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this2.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  var url;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this2.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        url = _context.sent;
                        _this2.formData.imgs.push({
                          url: url
                        });
                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile(index) {
      window.open(this.formData.imgs[index].url);
    },
    removeFile: function removeFile(index) {
      this.formData.imgs.splice(index, 1);
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    initReplayFormData: function initReplayFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.replayFormData = paramData;
      if (typeof this.$refs['formDataReplayVerify'] !== 'undefined') {
        this.$refs['formDataReplayVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    detailAndReplay: function detailAndReplay(row) {
      var _this3 = this;
      this.replayFormData.woId = row.id;
      this.searchReplayForm.woId = row.id;
      this.workOrderDetail = row;
      if (!row.readState) {
        this.$api[this.pageConfig.activeWorkOrderFunName](row.id).then(function (res) {
          if (res.data) {
            _this3.$message.success('已读');
            _this3.query();
          } else {
            _this3.$message.error('已读失败');
          }
        });
      }
      this.queryReplay();
      this.replayDialogTitle = this.pageConfig.editPageName + '详情与回复';
      this.replayDialogShow = true;
    },
    query: function query() {
      var _this4 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this4.tableData = res.data || [];
        _this4.totalCount = res.count;
        _this4.queryLoading = false;
      });
    },
    queryReplay: function queryReplay() {
      var _this5 = this;
      this.queryReplayLoading = true;
      this.$api[this.pageConfig.queryReplayFunName](this.searchReplayForm).then(function (res) {
        _this5.replayTableData = res.data || [];
        for (var i in res.data) {
          if (JSON.parse(res.data[i].imgs) && res.data[i].imgs !== '[]') {
            _this5.replayTableData[i].imgs = JSON.parse(res.data[i].imgs);
          } else {
            _this5.replayTableData[i].imgs = null;
          }
        }
        _this5.replayTotalCount = res.count;
        _this5.queryReplayLoading = false;
      });
    },
    submitReplayFormData: function submitReplayFormData() {
      var _this6 = this;
      this.$refs['formDataReplayVerify'].validate(function (valid) {
        if (valid) {
          _this6.$api[_this6.pageConfig.addReplayFunName](_this6.saveFormDataProcess(_this6.replayFormData)).then(function (res) {
            if (res.data) {
              _this6.$message.success('回复成功');
              _this6.initReplayFormData(_this6.emptyReplayFormData);
              _this6.replayDialogShow = false;
              _this6.query();
            } else {
              _this6.$message.error('回复失败');
            }
          });
        }
      });
    }
  }, "previewFile", function previewFile(path) {
    window.open(path);
  }), "closeReplayDialogShow", function closeReplayDialogShow() {
    this.replayDialogTitle = '';
    this.replayDialogShow = false;
    this.initReplayFormData(this.emptyReplayFormData);
  }), "search", function search() {
    this.searchForm.page = 1;
    this.query();
  }), "pageChange", function pageChange(page) {
    this.searchForm.page = page;
    this.query();
  }), "replayPageChange", function replayPageChange(page) {
    this.searchReplayForm.page = page;
    this.queryReplay();
  }), "sizeChange", function sizeChange(limit) {
    this.searchForm.page = 1;
    this.searchForm.limit = limit;
    this.query();
  }), "replaySizeChange", function replaySizeChange(limit) {
    this.searchReplayForm.page = 1;
    this.searchReplayForm.limit = limit;
    this.queryReplay();
  }), "sortChange", function sortChange(column) {
    this.searchForm.page = 1;
    this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
    this.query();
  })
};